// extracted by mini-css-extract-plugin
module.exports = {"list-view":"product-card-rating_list-view__QxMoG"};